import { transformSiteVariable } from '~/plugins/0.craftClient';

export const useSearchStore = defineStore('search', {
  state: () => ({
    isOpen: false,
    searchQuery: '',
    indexName: '',
    isHidden: false,
  }),

  getters: {
    getIsHidden: (state) => state.isHidden,
    getIsOpen: (state) => state.isOpen,
    getSearchQuery: (state) => state.searchQuery,
    getIndexName: (state) => state.indexName,
  },

  actions: {
    open() {
      this.isOpen = true;
    },

    close() {
      this.isOpen = false;
    },

    hide() {
      this.isHidden = true;
    },

    unhide() {
      this.isHidden = false;
    },

    setQuery(query) {
      this.searchQuery = query;
    },

    setIndexName() {
      const { $i18n } = useNuxtApp();
      const siteVariable = transformSiteVariable({ site: $i18n.locale.value }).site;

      this.indexName = 'page_' + siteVariable;
    },
  },
});
